import http from '@/services/api/http';

const getMapUrl = (route, useBrowseFilter) => {
  const apiRoute = `api/Public/${route}`;
  if (process.env.USE_API_WRAPPER && useBrowseFilter) {
    return `api/Public/GetLiveData?url=${encodeURIComponent(`/${apiRoute}`)}`;
  }

  return apiRoute;
};

export default {
  getMapLegend(mapName, useBrowseFilter = true) {
    const flag = useBrowseFilter ? 'true' : 'false';
    const route = `MapDataLegend/${encodeURIComponent(mapName)}?useBrowseFilter=${flag}`;
    const url = getMapUrl(route, useBrowseFilter);

    return http.get(url);
  },
  getMapData(mapName, useBrowseFilter = true) {
    const flag = useBrowseFilter ? 'true' : 'false';
    const route = `MapData/${encodeURIComponent(mapName)}?useBrowseFilter=${flag}`;
    const url = getMapUrl(route, useBrowseFilter);

    return http.get(url);
  },
  getContracts() {
    return this.getMapLegend('EC', true);
  },
  getStateData() {
    return this.getMapData('EC', true);
  },
  getContractsSenate() {
    return this.getMapLegend('SEN', true);
  },
  getStateDataSenate() {
    return this.getMapData('SEN', true);
  },
};



// WEBPACK FOOTER //
// ./src/services/api/map.js